import { TransactionRuleReviewWithReviewer } from "@common/schemas/transactionRuleReview.schema";
import { FiltersTypes } from "@common/types/filters/general";
import { RuleReviewStatus } from "@common/types/transactionRule";

export type RuleReviewFilters = Pick<
    FiltersTypes,
    "ruleReviewStatuses" | "ruleReviewerIds" | "ruleReviewerMode"
>;

interface RuleMatchesReviewFiltersParams {
    reviews: readonly TransactionRuleReviewWithReviewer[];
    filters: RuleReviewFilters;
}

export function ruleMatchesReviewFilters({
    reviews,
    filters: { ruleReviewStatuses, ruleReviewerIds, ruleReviewerMode },
}: RuleMatchesReviewFiltersParams): boolean {
    const isReviewed = reviews.length > 0;
    const isStatusMatch =
        !ruleReviewStatuses ||
        ruleReviewStatuses.length === 0 ||
        ruleReviewStatuses.includes(
            isReviewed
                ? RuleReviewStatus.REVIEWED
                : RuleReviewStatus.UNREVIEWED,
        );

    if (!ruleReviewerIds || ruleReviewerIds.length === 0) {
        return isStatusMatch;
    }

    const reviewerIds = new Set(reviews.map(({ userId }) => userId));
    const isReviewerMatch = (() => {
        switch (ruleReviewerMode) {
            case "all":
                return ruleReviewerIds.every((id) => reviewerIds.has(id));
            case "none":
                return !ruleReviewerIds.some((id) => reviewerIds.has(id));
            default:
                return ruleReviewerIds.some((id) => reviewerIds.has(id));
        }
    })();

    return isStatusMatch && isReviewerMatch;
}
